// do not use with the full name "hasOwnProperty"
// eslint will not catch missing import errors
// and you will get an obscur error
export default (obj, key) => Object.prototype.hasOwnProperty.call(obj, key)
